import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import { getRoles } from "../lib/api";
import { PRODUCT_IDENTITY } from "../lib/story";

export default function Logout({ signedIn, onClear }) {
  const [busy, setBusy] = useState(!!signedIn);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    getRoles()
      .then(({ data }) => setRoles(data?.roles || []))
      .catch(() => setRoles([]));
  }, []);

  useEffect(() => {
    if (!signedIn) {
      setBusy(false);
      return undefined;
    }
    let live = true;
    (async () => {
      await onClear();
      if (live) setBusy(false);
    })();
    return () => { live = false; };
  }, [signedIn, onClear]);

  return (
    <main className="logout-screen" data-testid="logout-page" aria-live="polite">
      <div className="logout-card">
        <div className="brand-mark">YUG<span>360</span><small>— MIND</small></div>
        <p className="kicker">{PRODUCT_IDENTITY.toUpperCase()}</p>
        <h1>{busy ? "Signing out…" : "You are signed out"}</h1>
        <p className="muted">Session cookies were cleared. Sign in again as any seeded role. Pointer text after login is a governance cue — use See details, Back and Next.</p>
        <div className="login-actions">
          <Link data-testid="logout-go-login" className="primary-button full" to="/login">Sign in</Link>
          <Link data-testid="logout-go-landing" className="secondary-button full" to="/">Back to product</Link>
        </div>
        {!!roles.length && (
          <div className="login-accounts" data-testid="logout-role-rows">
            {roles.map((row) => (
              <Link
                key={row.email || row.role}
                className="login-account"
                data-testid={`logout-role-${String(row.role || "").toLowerCase().replaceAll(" ", "-")}`}
                to={`/login?email=${encodeURIComponent(row.email || "")}`}
              >
                <strong>{row.role}</strong>
                <small>{row.email} · home {row.home}</small>
                <span>{row.pointer}</span>
              </Link>
            ))}
          </div>
        )}
        <div className="login-footer"><LockKeyhole size={14} /> Access token 15 minutes · refresh 7 days · httpOnly</div>
      </div>
    </main>
  );
}
